module.exports = __webpack_public_path__ + "img/im_download_image@2x.b3fbd123.jpg";